var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9994 23L11.9994 20M11.9994 16.5L11.9994 2",
    stroke: "currentColor",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamation);
export default __webpack_public_path__ + "static/media/exclamation.e7702fbd67a7d53e62f71ca2e8af64fd.svg";
export { ForwardRef as ReactComponent };